// ChemicalPage.js
// @flow
import * as React from 'react';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { observer } from 'mobx-react';
import Legend from '../components/Legend.js';
import Graphs from '../components/Graphs.js';
import Headline from '../components/Headline.js';
import Modal from '../components/Modal.js';
import safeUrl from '../util/safeUrl.js';
import * as _ from 'lodash'; // _.filter() etc
import helpers from '../util/helpers';

import "../css/Chemical.css";

type MoreInfoModalProps = {
  chemicalGroup: string,
  messageId: string,
  onClose: () => void,
};

class MoreInfoModal extends React.Component<MoreInfoModalProps> {
  render() {
    const messageIdFull = `chemicals.${this.props.chemicalGroup}.moreinfo.${this.props.messageId}`;

    return (
      <Modal onClose={this.props.onClose} className='more-info left-align' fullScreen={true}>
        <FormattedHTMLMessage id={messageIdFull} />
      </Modal>
    )
  }
}

const MoreButton = ({ onClick, id, classes }) => (
  <a className= {`button right secondary chem-more-tips-button ${classes}`} onClick={onClick}>
    <FormattedMessage id={id} />
  </a>
)

type Props = {
  appState: Object,
  chemicalGroup: string,
  match: Object,
  history: Object,
  intl: Object,
};

type State = {
  showMoreInfoModal: boolean,
  moreInfoMessageId: string,
  showAllActions: boolean,
};

class ChemicalPage extends React.Component<Props, State> {
  constructor() {
    super();
    this.state = { showMoreInfoModal: false, moreInfoMessageId: '' , showAllActions: false};

  }

  componentWillReceiveProps () {
    // for when you go between chemical pages, reset this state value
    this.setState({showAllActions:false})
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  avatarClicked(face) {
    let url = '/summary';
    helpers.eventLog("nav:chemicalpage:avatarClicked - " + face + " - " + url);
    this.props.appState.changeAvatar(face);
    this.props.history.push(url);
  }

  showModal(messageId, buttonid) {
    helpers.eventLog("modal - showMoreInfoModal." + messageId + " - " +buttonid);
    this.setState({ showMoreInfoModal: true, moreInfoMessageId: messageId });
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  }

  onClose() {
    this.setState({ showMoreInfoModal: false });
    document.getElementsByTagName("body")[0].style.overflow = "visible";
  }

  showMoreTips(){
    helpers.eventLog("modal - showMoreTips");
    this.setState({showAllActions: true})
  }

  showLessTips(){
    helpers.eventLog("modal - showLessTips");
    this.setState({showAllActions: false})
  }

  render() {
    const chemicalGroup = this.props.match.params.chemical;
    const buttonid = this.props.intl.messages['chemicals.'+chemicalGroup+'.moreinfo.desc_button'];

    let morebutton = <MoreButton onClick={() => this.showModal.bind(this)('description', buttonid)} id={buttonid} />

    let moremodal;

    if (helpers.findGetParameter('print'))
    {
      //inline for print #1 -- top MORE INFO (or PHOTOS) inlined
      const moreInfoMessageId2 = 'description';
      const messageIdFull = `chemicals.${chemicalGroup}.moreinfo.${moreInfoMessageId2}`;
      moremodal = <div id="inline_MoreInfoModal"><FormattedHTMLMessage id={messageIdFull} /></div>;
    }
    else
    {
      //normally
      moremodal = this.state.showMoreInfoModal ? (
        <MoreInfoModal
          onClose={this.onClose.bind(this)}
          chemicalGroup={chemicalGroup}
          messageId={this.state.moreInfoMessageId} />
      ) : null;
    }


    const iconPath = safeUrl(`/images/${this.props.intl.messages['chemicals.' + chemicalGroup + '.icon']}`);
    let hexColor = helpers.getIconColor(helpers.convertGroupName(chemicalGroup), this.props.intl)
    const icon = <span className='group-icon title-icon' style={{
        mask: `url(${iconPath})`,
        WebkitMask: `url(${iconPath}) 0% 0% / cover`,
        display: "inline-block",
        background: hexColor,
        WebkitMaskSize: "cover",
        maskSize: "cover",
        width: 40,
        height: 40,
      }}/>

    const headlines = this.props.appState.headlines.filter((d) => d.group.toLowerCase().replace(' ', '_') === this.props.match.params.chemical || (d.group === "Sunscreen Chemicals" && this.props.match.params.chemical === "sunscreen"))

    var headlineDisplay = headlines.length === 0 ? (
       <div />
    ) : headlines.map((headline, i) =>
        <Headline headline={headline} key={i} useAvatar={this.props.appState.avatar !== undefined} avatarName={this.props.appState.avatar} border={true} />
    );

    const actionsMessageId =  `chemicals.${chemicalGroup}.moreinfo.actions`;
    const actionsMessage = this.props.intl.messages[actionsMessageId];

    // let actionsReadMore;

    // if (helpers.findGetParameter('print'))
    // {
    //   //inline for print #2 -- more actions -- show inline -- use a p rather than a div since the initial action list is wrapped in a p
    //   //const moreInfoMessageId2 = 'actions';
    //   const messageIdFull = actionsMessageId; //`chemicals.${chemicalGroup}.moreinfo.${moreInfoMessageId2}`;
    //   console.log("actionsMessage for chemicalGroup="+chemicalGroup+"=>["+actionsMessage+"]");
    //   actionsReadMore = (actionsMessage !== undefined && actionsMessage !== "") ?
    //     <p id="inline_ActionsModal"><FormattedHTMLMessage id={messageIdFull}  /></p>: null;
    // }
    // else
    // {
    //   //normally
    //   actionsReadMore = (actionsMessage !== undefined && actionsMessage !== "") ?
    //     <MoreButton onClick={() => this.showModal.bind(this)('actions', "more")} id="more" /> : null;
    // }

    let affectmyhealth_inlinechemicals = "";

    if (helpers.findGetParameter('print'))
    {
      // inline for print #4 -- the graph buttons on chemical names -- list them inline in the "affectmyhealth" section here instead in modal button -- ChemicalModal -- in graphs
      const group_name_fixed = helpers.convertGroupName(chemicalGroup); // this.props.chemicalGroup.toLowerCase().replace(' ', '_')

      // see Graphs.js for looping thru chemicals in a chemicalGroup

      const chemicalGroupCaps = this.props.intl.messages['chemicals.' + chemicalGroup + '.data'] //  capitalized version needed to read the data
      const gData = this.props.appState.groups[chemicalGroupCaps]; // getData from Graphs.js --
      const myData = _.filter(gData, { mine: true });
      const chemicals = _.uniq(_.map(myData, 'chemical')); // the abbreviation forms
      const that = this;

      // parabens (for example) have no additional info -- e.g. chemicals.parabens.moreinfo.methyl paraben
      affectmyhealth_inlinechemicals = chemicals.map((chemical, i) => {
              const key = "chem"+i;
              const messageIdFull = `chemicals.${group_name_fixed}.moreinfo.${chemical}`;
              const msg = that.props.intl.messages[messageIdFull];
              if (msg != undefined && msg != "")
                return <div key={key}><FormattedHTMLMessage id={messageIdFull} /></div>;
              else
                return null;
            });

    }

    let self = this;
    let actionsReadMore;
    if (this.state.showAllActions) {
      actionsReadMore = <MoreButton onClick={this.showLessTips.bind(this)} id="show_less" classes="scroll-content arrow-up"/>
    } else {
      actionsReadMore = <MoreButton onClick={this.showMoreTips.bind(this)} id="show_more" classes="scroll-content " />

    }

    let additionalActions;
    if (this.state.showAllActions) {
      additionalActions = (
        <p className="chemical-more-tips">
          <FormattedHTMLMessage id={`chemicals.${chemicalGroup}.moreinfo.actions`} />
        </p>
      )
    }

    return (
      <div className="page chemical">



        <h1 className="title-vertical-align">
          {icon}
          <span className="title-vertical-align"><FormattedMessage id={`chemicals.${chemicalGroup}.title`} /></span>
        </h1>

        <div id="section1_headlines">
          {headlineDisplay}
        </div>

        <div id="section2_description">
          <h2>
            <FormattedMessage id={`chemicals.${chemicalGroup}.description_header`} />
          </h2>

          <p>
            <FormattedHTMLMessage id={`chemicals.${chemicalGroup}.description`} />
          </p>

          {morebutton}
          {moremodal}
        </div>

        <div className="page-break-no" id="section3_affectmyhealth">
          <h2>
            <FormattedMessage id={`chemicals.${chemicalGroup}.health_header`} />
          </h2>

          <p>
            <FormattedHTMLMessage id={`chemicals.${chemicalGroup}.health`} />
          </p>

          <div id="inline_section3_affectmyhealth_chemicals">{affectmyhealth_inlinechemicals}</div>

        </div>

        <div id="section4_yourresults">
          <h2>
            <FormattedMessage id='chemicals.text.results' defaultMessage='Your Results' />
          </h2>

          <p>
            <FormattedMessage id={`chemicals.${chemicalGroup}.graph.description`} />
          </p>

          <Legend appState={this.props.appState} group={this.props.intl.messages['chemicals.' + chemicalGroup + '.data']} chemicalGroup={chemicalGroup}/>
          <p className="graphs-click-to-expand">
            <FormattedMessage id='click_to_expand_graph' defaultMessage="Click on any graph to see an expanded version with more details." />
          </p>
          <Graphs appState={this.props.appState} group={this.props.intl.messages['chemicals.' + chemicalGroup + '.data']} />
          <p className="graphs-click-to-expand">
            <FormattedMessage id='click_to_expand_graph' defaultMessage="Click on any graph to see an expanded version with more details." />
          </p>
        </div>

        <div className="page-break-no" id="section5_whatcanido">
          <h2>
            <FormattedMessage id='chemicals.text.actions' defaultMessage='What can I do?' />
          </h2>

          <p className="chemical-first-tips">
            <FormattedHTMLMessage id={`chemicals.${chemicalGroup}.actions`} />
          </p>

          {additionalActions}

          {actionsReadMore}
        </div>

      </div>
    );
  }
}

export default injectIntl(observer(ChemicalPage));



// WEBPACK FOOTER //
// ./src/pages/ChemicalPage.js